import {Button} from 'finform';
import {Url} from 'finhelper';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {CenteredWrapper, Container} from '#app/components/layout/styles';

import notFoundImage from './images/swan.png';
import {Img, ImgContainer, NotFoundContainer, Text, Title} from './styles';

interface NotFoundState {
    statuses: any[];
}

class NotFound extends Component<Record<string, unknown>, NotFoundState> {
    constructor(props: Record<string, unknown>) {
        super(props);
        this.state = {
            statuses: [],
        };
    }

    render() {
        const url = Url.getCurrentUrl();

        return (
            <Container
                style={{
                    margin: url.indexOf('/cabinet') !== -1 ? '0 auto' : '20px auto 0 auto',
                }}
            >
                <CenteredWrapper>
                    <NotFoundContainer>
                        <ImgContainer>
                            <Img src={notFoundImage ?? ''} alt=""/>
                        </ImgContainer>
                        <Title>Ничего не найдено</Title>
                        <Text>Попробуйте вернуться назад или поищите что-нибудь другое.</Text>
                        <Text>Код ошибки: 404</Text>
                        <Link to={url.indexOf('/cabinet') !== -1 ? '/cabinet' : '/'}>
                            <Button type="link" className="style1">
                                На главную
                            </Button>
                        </Link>
                    </NotFoundContainer>
                </CenteredWrapper>
            </Container>
        );
    }
}

const enhance = connect(
    () => ({}),
    {}
);

export default enhance(NotFound);
